import { supabase } from '../supabaseClient'

const CHUNK = 100

async function consultarEmLotes(ids, consultar) {
  const mapa = {}
  for (let i = 0; i < ids.length; i += CHUNK) {
    Object.assign(mapa, await consultar(ids.slice(i, i + CHUNK)))
  }
  return mapa
}

export async function registrarAcessoUsuario({ usuarioId, empresaId, origem = 'web' }) {
  if (!usuarioId) return
  try {
    const { error } = await supabase.from('usuarios_acessos').insert([{
      usuario_id: usuarioId,
      empresa_id: empresaId || null,
      origem,
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null
    }])
    if (error) throw error
  } catch (err) {
    console.warn('Não foi possível registrar o acesso do usuário:', err?.message || err)
  }
}

function montarMapa(rows) {
  const mapa = {}
  for (const row of rows || []) {
    const id = row.usuario_id
    if (!id || mapa[id]) continue
    mapa[id] = row
  }
  return mapa
}

export async function listarUltimosAcessos(usuarioIds) {
  const ids = (usuarioIds || []).filter(Boolean)
  if (ids.length === 0) return {}

  const pelaView = async (lote) => {
    const { data, error } = await supabase
      .from('usuarios_ultimo_acesso')
      .select('usuario_id, data_acesso, origem, user_agent')
      .in('usuario_id', lote)
    if (error) throw error
    return montarMapa(data)
  }

  try {
    return await consultarEmLotes(ids, pelaView)
  } catch (err) {
    const pelaTabela = async (lote) => {
      const { data, error } = await supabase
        .from('usuarios_acessos')
        .select('usuario_id, data_acesso, origem, user_agent')
        .in('usuario_id', lote)
        .order('data_acesso', { ascending: false })
        .limit(1000)
      if (error) throw error
      return montarMapa(data)
    }
    try {
      return await consultarEmLotes(ids, pelaTabela)
    } catch (err2) {
      console.warn('Erro ao carregar últimos acessos:', err2?.message || err?.message || err2)
      return {}
    }
  }
}

export async function listarHistoricoAcessos(usuarioId, limite = 100) {
  if (!usuarioId) return []
  const { data, error } = await supabase
    .from('usuarios_acessos')
    .select('id, data_acesso, origem, user_agent, ip')
    .eq('usuario_id', usuarioId)
    .order('data_acesso', { ascending: false })
    .limit(limite)
  if (error) throw error
  return data || []
}

